import { motion } from 'framer-motion';
import { ReactNode, memo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: ReactNode;
}

export const PageTransition = memo(function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();
  
  useEffect(() => {
    console.log('[PageTransition] Rendering for path:', location.pathname);
    const startTime = Date.now();
    
    return () => {
      console.log('[PageTransition] Transition duration:', Date.now() - startTime, 'ms');
    };
  }, [location.pathname]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onAnimationStart={() => console.log('[PageTransition] Animation started')}
      onAnimationComplete={() => console.log('[PageTransition] Animation completed')}
      transition={{
        duration: 0.15,
        ease: "easeInOut"
      }}
      className="md:pt-0 pt-8 relative"
    >
      {children}
    </motion.div>
  );
}
)